import { Component, OnInit, Input, OnChanges, SimpleChange, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Params } from '../../../../../transactions/pages/list/models/params.model';
import { UserService } from '../../../../../../core/services/user.service';
import { ServicesLogosService } from '../../../../../../core/services/services-logos.service';

@Component({
  selector: 'app-flow-autorization-scheme-alternative',
  templateUrl: './flow-autorization-scheme-alternative.component.html',
})
export class FlowAuthorizationSchemeAlternativeComponent implements OnInit {

  @Input() flow_order: any;
  @Input() expandedStepState;
  @Input() authorization_scheme;
  @Input() onlyViewer;
  @Output() removeASAlternative = new EventEmitter();

  model: any = {};
  params: Params;

  constructor(private route: ActivatedRoute,
    private ServicesLogosService: ServicesLogosService,
    private userService: UserService) { }

  ngOnInit(): void {
    this.model.user = this.userService.user;
    this.authorization_scheme.steps.forEach(step => {
      if (step) {
        if (step.first_service) {
          if (step.first_service.name)
            step.first_service.image_path = this.ServicesLogosService.getLogo(step.first_service);
        }
        if (step.second_service) {
          if (step.second_service.name)
            step.second_service.image_path = this.ServicesLogosService.getLogo(step.second_service);
        }
        if (step.third_service) {
          if (step.third_service.name)
            step.third_service.image_path = this.ServicesLogosService.getLogo(step.third_service);
        }
      }
    });

    this.route.paramMap.subscribe((params) => {
      this.params = new Params(params);
      this.model.partner = params.get('partner');
      this.model.account = params.get('account');
    });

  }
  remove(event: any) {
    this.removeASAlternative.emit();
    event.stopPropagation();
  }

  editStep(event: any) {
    event.stopPropagation();
  }

}
